import {Button} from 'antd'
import http from '@/biz/http.mjs'
import runAsync from '@/script/runAsync.mjs'
import useAlert from '@/biz/useAlert.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default function ButtonExportFpReqDoc(props) {
    const map = useMapContext()
    const selectedNodes = [...map.useSelectedNodes()]
    const alert = useAlert()

    if (selectedNodes.length !== 1) {
        return null
    }

    const node = selectedNodes[0]
    const {bdId, pkid, bizNodeType} = node.data

    if (!pkid || 'BDLOGIC' !== bizNodeType) {
        return null
    }

    const handleClick = async () => {
        const {prjId, sVer} = map.data

        await runAsync(
            () => http.post(
                '/prd/export/fp/reqdoc',
                {prjId, sVer, bdId, bdlogicIds: [pkid]}
            ),
            {action: '导出程序能力软件需求'}
        )

        alert.generatingFile()
    }

    return (
        <Button
            onClick={handleClick}
            {...props}
        >
            导出程序能力软件需求
        </Button>
    )
}
